import { render, staticRenderFns } from "./SchoolInformationItem.vue?vue&type=template&id=7b66d1e8&scoped=true"
import script from "./SchoolInformationItem.vue?vue&type=script&lang=js"
export * from "./SchoolInformationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b66d1e8",
  null
  
)

export default component.exports